import { useMemo } from 'react'
import { formatDuration } from 'date-fns'

interface DurationDisplayProps {
  seconds: number
}
export function DurationDisplay({
  seconds,
}: DurationDisplayProps) {
  const time = useMemo(() => {
    let minutes = Math.floor(seconds / 60)
    let hours: number | undefined
    if (minutes >= 60) {
      hours = Math.floor(minutes / 60)
      minutes = minutes % 60
    }
    return formatDuration({ hours, minutes })
      .replace(/\s?hours?/, 'h')
      .replace(/\s?minutes?/, 'm')
  }, [seconds])
  return <time>{time}</time>
}
